import { Merchandise, MerchandiseTypes } from '@beable/roster-backend-client-v1';
import { AppBar, Grid, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Header from '../../Header/Header';
import { SubHeader } from '../../Common/Layout/SubHeader';
import { BasePaper } from '../../Common/Layout/BasePaper';
import QuestionHelpPricingTable, { QuestionHelpRow } from './QuestionHelpPricingTable';
import RosterBackendService from '../../../services/RosterBackendService';
import { UserExperience } from '@beable/content-types';
import QuestionHelpLessonLimits from './QuestionHelpLessonLimits';

const QuestionHelpMerchType = MerchandiseTypes.QuestionHelp;

enum ManageQuestionHelpsTabs {
    Pricing = 'Pricing',
    SpendingLimits = 'Spending Limits',
}

export default function ManageQuestionHelps() {
    const allUserExperiences = Object.values(UserExperience);
    // `merchandiseRecords` gets set when the component loads and on saving pricing
    const [merchandiseRecords, setMerchandisePricing] = useState<Merchandise[]>([]);
    const [activeTab, setActiveTab] = useState<ManageQuestionHelpsTabs>(ManageQuestionHelpsTabs.Pricing);
    const fetchMerchandise = async () => {
        const getMerchResponse = await RosterBackendService.getMerchandiseByType(QuestionHelpMerchType);
        if (getMerchResponse.isOk()) {
            setMerchandisePricing(getMerchResponse.value);
        }
    };

    useEffect(() => {
        fetchMerchandise();
    }, []);

    const handleTabChange = (event: React.SyntheticEvent, newValue: ManageQuestionHelpsTabs) => {
        setActiveTab(newValue);
    };

    const onPricingSave = async (rows: QuestionHelpRow[]) => {
        for (const { 
            type: questionHelpType, price, descriptionEn:description_en , descriptionEs:description_es
        } of rows) {
            const existingMerch = merchandiseRecords.find(merch => merch.name === questionHelpType);

            if (!existingMerch) {
                await RosterBackendService.addMerchandise({
                    name: questionHelpType,
                    type: QuestionHelpMerchType,
                    price,
                    active: true,
                    experiences: allUserExperiences,
                    description_en,
                    description_es
                });

            } else if (
                existingMerch.price !== price
                || existingMerch.description_en !== description_en
                || existingMerch.description_es !== description_es
            ) {
                await RosterBackendService.updateMerchandise({
                    id: existingMerch.id,
                    price,
                    description_en,
                    description_es
                });
            }
        }
        fetchMerchandise();
    };

    return (
        <div >
            <Header />
            <SubHeader>
                <Typography variant='h6' component='span'>Manage Question Helps: {activeTab}</Typography>
            </SubHeader>
            <Grid container sx={{
                justifyContent: 'center'
            }}>
                <Grid size={10}>
                    <BasePaper>
                        <AppBar position="static">
                            <Tabs
                                value={activeTab}
                                onChange={handleTabChange}
                                textColor="inherit"
                                indicatorColor='secondary'
                            >
                                <Tab 
                                    label="Question Help Pricing" 
                                    value={ManageQuestionHelpsTabs.Pricing} 
                                    data-cy="tab-pricing"
                                />
                                <Tab 
                                    label="Lesson Spending Limits" 
                                    value={ManageQuestionHelpsTabs.SpendingLimits} 
                                    data-cy="tab-spending-limits"
                                />
                            </Tabs>
                        </AppBar>

                        {activeTab === ManageQuestionHelpsTabs.Pricing &&
                            <QuestionHelpPricingTable
                                merchandise={merchandiseRecords}
                                onSave={onPricingSave}
                            />
                        }
                        {activeTab === ManageQuestionHelpsTabs.SpendingLimits &&
                            <QuestionHelpLessonLimits />
                        }
                    </BasePaper>
                </Grid>
            </Grid>
        </div>
    );
}